'use client';

import { type FC, useMemo } from 'react';

import { DropdownFloatingContext } from './context/dropdown-floating.context';
import { DropdownRootContext } from './context/dropdown-root.context';
import { useDropdown } from './hooks/use-dropdown';
import type { DropdownRootPropsInterface } from './types/dropdown-root.types';

/**
 * @since 10.0.0
 */
export const DropdownRoot: FC<DropdownRootPropsInterface> = (props: DropdownRootPropsInterface) => {
  const { children, ...rest } = props;
  const { dropdown, floating } = useDropdown(rest);
  const contextValue = useMemo(() => ({ dropdown }), [dropdown]);
  return (
    <DropdownRootContext.Provider value={contextValue}>
      <DropdownFloatingContext.Provider value={floating}>
        {children}
      </DropdownFloatingContext.Provider>
    </DropdownRootContext.Provider>
  );
};

DropdownRoot.displayName = 'Dropdown.Root';
